import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';
import MosCheckbox from '@mos-front-components/public/es/components/MosCheckbox';
import TextArea from '@mos-cat/text-area';

import './Table.pcss';
import { processTable } from './processTable';

const prepareVisual = (htmlTable = '') => {
  return htmlTable
    .replace('Максимальный первичный балл', 'Макс. балл')
    .replace('Название критерия*', 'Название критерия');
};

const getMarkup = htmlTable => ({ __html: prepareVisual(htmlTable) });

class Table extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      markup: getMarkup(props.htmlTable)
    };
    this.textFieldRef = React.createRef();
    this.checkboxRef = React.createRef();
    this.tableReference = React.createRef();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState(state => ({
      ...state,
      markup: getMarkup(nextProps.htmlTable)
    }));
  }

  updateTable() {
    const {
      onUpdateAppealData,
      data,
      indexOfTable,
      showOnlyIncorrect
    } = this.props;

    const tableNode = this.tableReference.current;
    const commentNode = this.textFieldRef.current;
    const checkboxNode = this.checkboxRef.current;
    const taskNumbers = data.map(task => task.task_number) || [];

    const table = tableNode.querySelector('table');
    const params = {
      tableRawHtml: table,
      checkboxNode,
      commentNode,
      onUpdateAppealData,
      checkedTaskNumbers: taskNumbers,
      tasksWithInformation: data,
      showOnlyIncorrect,
      indexOfTable
    };
    processTable(params);

    const element = this.tableReference.current.querySelector(
      '.type-title.Table_info'
    );
    if (element) {
      const {
        showOnlyIncorrect,
        onToggleShowOnlyIncorrect,
        indexOfTable,
        saveDraft
      } = this.props;

      let newRow = element.nextSibling;

      if (!newRow || !newRow.classList.contains('checkbox-row')) {
        const newCol = document.createElement('td');

        newRow = document.createElement('tr');
        newRow.classList.add('checkbox-row');
        newRow.classList.add('Table_info');
        newCol.setAttribute('colspan', '4');
        newRow.appendChild(newCol);

        element.insertAdjacentElement('afterend', newRow);
      }

      const checkboxRoot = newRow.querySelector('td');

      if (checkboxRoot) {
        ReactDOM.render(
          <MosCheckbox
            checked={showOnlyIncorrect}
            onChange={() => {
              onToggleShowOnlyIncorrect(indexOfTable);
              saveDraft();
            }}
            className={'Table__filter__only-incorrect'}
          >
            Только задания, по которым получено 0&nbsp;баллов
          </MosCheckbox>,
          checkboxRoot
        );
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.data) {
      this.updateTable();
    }
  }

  componentDidMount() {
    this.updateTable();
  }

  render() {
    const { markup } = this.state;

    const { className, showOnlyIncorrect } = this.props;

    return (
      <div
        className={cn('Table', className, {
          Table_onlyIncorrect: showOnlyIncorrect
        })}
      >
        <div ref={this.tableReference} dangerouslySetInnerHTML={markup} />
        <div ref={this.checkboxRef} style={{ display: 'none' }}>
          <MosCheckbox>%number%</MosCheckbox>
        </div>
        <div ref={this.textFieldRef} style={{ display: 'none' }}>
          <div className="Table__answers-comment">
            <TextArea
              className="Table__answers-comment-text-field"
              name="Table__answers-comment-text-field"
              label="Комментарий"
              maxLength={1000}
            />
          </div>
        </div>
      </div>
    );
  }
}

Table.propTypes = {
  corrected: PropTypes.bool,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      answer: PropTypes.string,
      number: PropTypes.string,
      mark: PropTypes.number,
      max_mark: PropTypes.number,
      checked: PropTypes.bool
    })
  ).isRequired,
  className: PropTypes.string,
  onToggleShowOnlyIncorrect: PropTypes.func.isRequired
};

Table.defaultProps = {
  className: '',
  corrected: false,
  grouped: false,
  gve: false
};

export default Table;
